  export const actionTypes = {
    SET_STEP: "SET_STEP",
    UPDATE_FEEDBACK: "UPDATE_FEEDBACK",
    REMOVE_OPTION: "REMOVE_OPTION",
    COMPLETE_OPTION: "COMPLETE_OPTION",
    SUBMIT_FEEDBACK: "SUBMIT_FEEDBACK",
    SELECTED_OPTION:"SELECTED_OPTION",
    SET_CURRENT_OPTION_SELECTED :"SET_CURRENT_OPTION_SELECTED",
    SET_EXPERIENCE_SELECTED : 'SET_EXPERIENCE_SELECTED',
    SET_TEAMS_VIDEO_ROOM_FEEDBACK: "SET_TEAMS_VIDEO_ROOM_FEEDBACK",
    SET_DIGITAL_SERVICE_FEEDBACK: "SET_DIGITAL_SERVICE_FEEDBACK",
    SET_IT_SERVICE_DESK_FEEDBACK: "SET_IT_SERVICE_DESK_FEEDBACK",
    SET_MOBILE_TELEPHONY_FEEDBACK: "SET_MOBILE_TELEPHONY_FEEDBACK",  
    SET_OFFICE_NETWORK_FEEDBACK: "SET_OFFICE_NETWORK_FEEDBACK",
    SET_PHILIPS_IT_FEEDBACK: "SET_PHILIPS_IT_FEEDBACK",
    SET_IT_EXPERIENCE_FEEDBACK: "SET_IT_EXPERIENCE_FEEDBACK",
  };

  export const setStep = (step, subStep) => ({
    type: actionTypes.SET_STEP,
    payload: { step, subStep },
  });

  export const updateFeedback = (option, field, value) => ({
    type: actionTypes.UPDATE_FEEDBACK,
    payload: { option, field, value },
  });
  export const removeOption = (option) => ({
    type: actionTypes.REMOVE_OPTION,
    payload: { option },
  });

  export const completeOption = (option) => ({
    type: actionTypes.COMPLETE_OPTION,
    payload: { option },
  });

  export const submitFeedback = () => ({
    type: actionTypes.SUBMIT_FEEDBACK,
  });


  export const setCurrentOptionSelected = (option) => ({
    type: actionTypes.SET_CURRENT_OPTION_SELECTED,
    payload: option,
  });

  export const setExperienceSelected = (option, isSelected) => ({
    type: actionTypes.SET_EXPERIENCE_SELECTED,
    payload: { option, isSelected },
  });

  export const setTeamsVideoRoomResponse = (option, question, response) => ({
    type: actionTypes.SET_TEAMS_VIDEO_ROOM_FEEDBACK,
    payload: { option, question, response },
  });

  export const setDigitalServiceResponse = (option, questionKey, question, response) => ({
    type: actionTypes.SET_DIGITAL_SERVICE_FEEDBACK,
    payload: { option, questionKey, question, response },
  });  

  export const setITServiceDeskResponse = (option, questionKey, question, response, comment = null) => ({
    type: actionTypes.SET_IT_SERVICE_DESK_FEEDBACK,
    payload: { option, questionKey, question, response, comment },
  });

  export const setMobileTelephonyFeedback = (option, mainCategory, subCategory, comments) => ({
    type: actionTypes.SET_MOBILE_TELEPHONY_FEEDBACK,
    payload: { option, mainCategory, subCategory, comments },
  });

  export const setOfficeNetworkFeedback = (option, question, selectedOptions = [], feedbackPrompt, comments) => ({
    type: actionTypes.SET_OFFICE_NETWORK_FEEDBACK,
    payload: { option, question, selectedOptions, feedbackPrompt, comments },
  });

  export const setPhilipsITFeedback = (option, question) => ({
    type: actionTypes.SET_PHILIPS_IT_FEEDBACK,
    payload: { option, question },
  });

  export const setITExperienceFeedback = (option, question, comments, itExperienceLocation) => ({
    type: actionTypes.SET_IT_EXPERIENCE_FEEDBACK,
    payload: { option, question, comments, itExperienceLocation },
  });